import { render, staticRenderFns } from "./ClientProjectsVisits.vue?vue&type=template&id=2b23f32e"
import script from "./ClientProjectsVisits.vue?vue&type=script&lang=ts"
export * from "./ClientProjectsVisits.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b23f32e')) {
      api.createRecord('2b23f32e', component.options)
    } else {
      api.reload('2b23f32e', component.options)
    }
    module.hot.accept("./ClientProjectsVisits.vue?vue&type=template&id=2b23f32e", function () {
      api.rerender('2b23f32e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/ClientProjectsVisits.vue"
export default component.exports